import { Dispatch } from 'redux';
import axios from 'axios';
import { Category } from '../reducers/CategoryReducer';
import { E_LEARNING_API_BASE_URL } from '../../config/config';

export const getCategoryList = () => {
  return async (dispatch: Dispatch) => {
    dispatch({ type: 'CATEGORY_LOADING' });

    try {
      const response = await axios.get<Category[]>(`${E_LEARNING_API_BASE_URL}categories`);
      dispatch({ type: 'CATEGORY_SUCCESS', payload: response.data });
    } catch (error: any) {
      dispatch({ type: 'CATEGORY_ERROR', payload: error.message });
    }
  };
};

